import { ReactNode, createContext, useReducer } from 'react';
import {
  AdvancedSearchReducer,
  IAdvancedSearchState,
} from 'reducer/PaymentsAndDeductions/AdvancedSearchReducer';

interface IAdvancedSearchContext {
  advancedSearch: IAdvancedSearchState;
  dispatchAdvancedSearch: Function;
}

export const AdvancedSearchContext = createContext<IAdvancedSearchContext>({
  advancedSearch: {
    requestState: null,
    requestNumber: null,
    requestType: {
      payment: false,
      deduction: false,
      refund: false,
    },
    dateRange: {
      start: null,
      end: null,
      isYear: false,
    },
    activeSearch: {
      text: false,
      advanced: false,
    },
    dateMinMaxRange: {
      min: new Date(),
      max: new Date(),
    },
    requestNumberList: [],
  },
  dispatchAdvancedSearch: () => {},
});

type Props = { children: ReactNode };

export const AdvancedSearchContextProvider = ({ children }: Props) => {
  const [advancedSearch, dispatchAdvancedSearch]: [
    IAdvancedSearchState,
    Function
  ] = useReducer(AdvancedSearchReducer, {
    requestState: null,
    requestNumber: null,
    requestType: {
      payment: false,
      deduction: false,
      refund: false,
    },
    dateRange: {
      start: null,
      end: null,
      isYear: false,
    },
    activeSearch: {
      text: false,
      advanced: false,
    },
    dateMinMaxRange: {
      min: new Date(),
      max: new Date(),
    },
    requestNumberList: [],
  });

  return (
    <AdvancedSearchContext.Provider
      value={{
        advancedSearch,
        dispatchAdvancedSearch,
      }}
    >
      {children}
    </AdvancedSearchContext.Provider>
  );
};
